import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  //mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  // redirect to dashboard after complete subscription
  if (from.name === null && to.name === 'subscription-choose-plan') {
    next({ name: 'dashboard' });
  }
  else {
    next();
  }
});

export default router;
